import { X } from "lucide-react";

export default function AdminEmailTemplates({ ctx }) {
  const { emailTemplates, resetTemplate, previewTemplate, saveTemplate, tplDraft, setTplDraft, tplPreview, setTplPreview } = ctx;
  return (
    <div className="mt-10 space-y-8" data-testid="admin-emailtemplates">
      <p className="text-sm text-stone-500">Edit the wording of automated emails. The branded layout and auto-filled details (class name, date, etc.) stay intact. Use the variables shown — they're swapped in automatically when the email is sent.</p>
      {emailTemplates.map((tpl) => (
        <div key={tpl.key} data-testid={`email-tpl-${tpl.key}`} className="border-2 border-[#121212] bg-white p-6 space-y-4">
          <div className="flex items-center justify-between flex-wrap gap-3">
            <h3 className="font-serif font-black text-2xl text-[#121212]">{tpl.label}</h3>
            <div className="flex gap-2">
              <button data-testid={`tpl-reset-${tpl.key}`} onClick={() => resetTemplate(tpl)} className="px-3 py-2 text-xs tracking-[0.15em] uppercase font-bold border-2 border-[#121212]/30 text-[#121212]/70 hover:border-[#121212]">Reset to default</button>
              <button data-testid={`tpl-preview-${tpl.key}`} onClick={() => previewTemplate(tpl.key)} className="px-3 py-2 text-xs tracking-[0.15em] uppercase font-bold border-2 border-[#121212] text-[#121212] hover:bg-[#F2E9D8]">Preview</button>
              <button data-testid={`tpl-save-${tpl.key}`} onClick={() => saveTemplate(tpl.key)} className="px-4 py-2 text-xs tracking-[0.15em] uppercase font-bold bg-[#121212] text-[#F2E9D8] hover:bg-black">Save</button>
            </div>
          </div>
          <div className="text-xs text-[#121212]/60">
            Available variables: {tpl.variables.map((v) => <code key={v} className="mx-1 px-1.5 py-0.5 bg-[#F2E9D8] rounded">{v}</code>)}
          </div>
          <div className="space-y-3">
            {tpl.fields.map((f) => (
              <div key={f.key}>
                <label className="block text-xs tracking-[0.2em] uppercase font-bold text-[#121212]/70 mb-1">{f.label}</label>
                {f.type === "textarea" ? (
                  <textarea data-testid={`tpl-${tpl.key}-${f.key}`} rows={2} value={tplDraft[tpl.key]?.[f.key] ?? ""} onChange={(e) => setTplDraft((d) => ({ ...d, [tpl.key]: { ...d[tpl.key], [f.key]: e.target.value } }))} className="w-full px-3 py-2 border-2 border-[#121212]/20 focus:border-[#121212] focus:outline-none text-sm" />
                ) : (
                  <input data-testid={`tpl-${tpl.key}-${f.key}`} value={tplDraft[tpl.key]?.[f.key] ?? ""} onChange={(e) => setTplDraft((d) => ({ ...d, [tpl.key]: { ...d[tpl.key], [f.key]: e.target.value } }))} className="w-full px-3 py-2 border-2 border-[#121212]/20 focus:border-[#121212] focus:outline-none text-sm" />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      {tplPreview && (
        <div data-testid="tpl-preview-modal" className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-6" onClick={() => setTplPreview(null)}>
          <div className="bg-white max-w-xl w-full max-h-[80vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-5 py-3 border-b border-stone-200">
              <p className="text-sm font-bold">Subject: {tplPreview.subject}</p>
              <button data-testid="tpl-preview-close" onClick={() => setTplPreview(null)} className="text-stone-400 hover:text-[#121212]"><X size={18} /></button>
            </div>
            <iframe title="preview" srcDoc={tplPreview.html} className="w-full h-[60vh] border-0" />
          </div>
        </div>
      )}
    </div>
  );
}
